module.exports = __webpack_public_path__ + "img/jiniantang4.17b5c941.png";